import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/theme-github";
import styles from './editor.module.css'

export const Editor = ({ program, handleSave, role, teacherCopy, studentActivityId, onCodeChange,currentFileId }) => {

    const handleChange = (val) => {
        AceEditor.value = val;
        if (onCodeChange) onCodeChange(val);
    }

    var timer;
    const endAndStartTimer = () => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            // console.log("saving");
            handleSave();
            // console.log("saved");
        }, 5000)
    }

    return (
        <div className={styles.editorWrapper}>
            <div className={styles.editorLabel}>✏️ Write your Python code here</div>
            <AceEditor
                currentFileId={currentFileId}
                height="calc(100% - 34px)"
                width="100%"
                placeholder="Enter code here!"
                mode="python"
                theme="github"
                onChange={handleChange}
                value={program}
                readOnly={(role === "teacher" && teacherCopy != true && studentActivityId == null) ? true : false}
                fontSize={16}
                showPrintMargin={false}
                showGutter={true}
                highlightActiveLine={true}
                setOptions={{ showLineNumbers: true }}
            />
        </div>
    )
}